export const getChartColor = (index: number): string => {
  const colors = [
    'chartColors-color1',
    'chartColors-color2',
    'chartColors-color3',
    'chartColors-color4',
    'chartColors-color5',
    'chartColors-color6',
  ];

  return colors[index] || colors[colors.length - 1];
};

export const checkboxColors = [
  '#427CCF',
  '#6FE5B9',
  '#B860F4',
  '#E95382',
  '#F1C253',
  '#844BA8',
  '#4A9E86',
  '#98A5A6',
  '#D9833B',
  '#D65746',
  '#9BE0D5',
  '#D2F5C9',
  '#D4716E',
  '#B793D0',
];

// Colors for each campaign type for use in the campaign types modal
export const CampaignTypesCategoryColors = [
  '#377DD2',
  '#3CE7B7',
  '#C55EF9',
  '#F94A83',
  '#F7C145',
  '#8D49AA',
];
